import {
  ADMIN_REGISTER_USER_REQUEST,
  ADMIN_REGISTER_USER_SUCCESS,
  ADMIN_REGISTER_USER_FAIL,
  ADMIN_REGISTER_USER_RESET,
  ADMIN_UPDATE_USER_REQUEST,
  ADMIN_UPDATE_USER_SUCCESS,
  ADMIN_UPDATE_USER_FAIL,
  ADMIN_UPDATE_USER_RESET,
  ADMIN_GET_USER_REQUEST,
  ADMIN_GET_USER_SUCCESS,
  ADMIN_GET_USER_FAIL,
  ADMIN_GET_USER_RESET
} from '../constants/adminConstants'

export const adminRegisterReducer = (state = {}, action) => {
  switch (action.type) {
    case ADMIN_REGISTER_USER_REQUEST:
      return { loading: true }
    case ADMIN_REGISTER_USER_SUCCESS:
      return { loading: false, success: true, adminUser: action.payload }
    case ADMIN_REGISTER_USER_FAIL:
      return { loading: false, error: action.payload }
    case ADMIN_REGISTER_USER_RESET:
      return {}
    default:
      return state
  }
}

export const adminUpdateuserReducer = (state = { adminUser: {} }, action) => {
  switch (action.type) {
    case ADMIN_UPDATE_USER_REQUEST:
      return { loading: true }
    case ADMIN_UPDATE_USER_SUCCESS:
      return {
        loadingUpdate: false,
        successUpdate: true,
        adminUser: action.payload
      }
    case ADMIN_UPDATE_USER_FAIL:
      return { loading: false, errorUpdate: action.payload }
    case ADMIN_UPDATE_USER_RESET:
      return { adminUser: {} }
    default:
      return state
  }
}

export const adminGetuserReducer = (state = { adminUser: {} }, action) => {
  switch (action.type) {
    case ADMIN_GET_USER_REQUEST:
      return { loadingGet: true }
    case ADMIN_GET_USER_SUCCESS:
      return { loadingGet: false, successGet: true, adminUser: action.payload }
    case ADMIN_GET_USER_FAIL:
      return { loadingGet: false, errorGet: action.payload }
    case ADMIN_GET_USER_RESET:
      return { adminUser: {} }
    default:
      return state
  }
}
